import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('vehicle-request/index', {params});
    },
    show(id) {
        return Service().get('vehicle-request/show/'+id);
    },
    create(params) {
        return Service().post('vehicle-request/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('vehicle-request/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('vehicle-request/delete/'+id);
    },
    getDriver(params) {
        return Service().get('vehicle-request/get-vehicle-request', {params});
    },
}